import initialState from './initialState';

export default function sessionReducer(state = initialState.session, action){

  switch(action.type){
    case 'ADD_SESSION':
      return Object.assign({}, state, {
        session_id: action.session_id
      })

    case 'REMOVE_SESSION':
      return Object.assign({}, state, {
        session_id: null
      })

    default:
      return state
  }
}